<template>
  <b-form @submit.prevent="submitForm">
    <b-row class="mb-2 py-2 align-items-center">
      
      <b-col v-for="(field, index) in tableFields" :key="'field' + index" :md="field.md">
        <slot :name="`field(${getFieldKey(field)})`" :row="form_data" />
      </b-col>

    </b-row>

    <div class="d-flex justify-content-end">
      <b-button variant="danger" class="mx-2" @click="$emit('close')">
        Cancel
      </b-button>
      <b-button variant="success" @click="submitForm">
        <i class="fa fa-save" /> Save
      </b-button>
    </div>
  </b-form>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import AnalyteRangeRepository from '@/repositories/lab/AnalyteRangeRepository';
import { analyteRangeNotifications } from '@/shared/notifications';
import { notificationOptions } from '@/shared/toast-notification-options';

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'SampleTypeAnalyteRangeAddForm',
  props: {
    sample_type: {
      type: Object,
      default: () => null
    },
    fields: {
      type: Array,
      default: () => null
    },
  },
  data () {
    return {
      form_data: {},
      savingForm: false
    }
  },
  computed: {
    tableFields () {
      return this.fields || (this.item && Object.keys(this.item))
    }
  },
  created () {
    this.form_data = this.fields.reduce((acc, field) => {
      acc[this.getFieldKey(field)] = field.defaultValue != undefined ? field.defaultValue :  null
      return acc
    }, {})
  },
  methods: {
    getFieldKey (field) {
      return field.name || field
    },

    async submitForm () {
      this.savingForm = true

      try {
        await AnalyteRangeRepository.create(this.form_data)

        this.addSuccess()
        this.$emit('saved')
        this.$emit('close')
      } catch (error) {
        this.addFail()
      }

      this.savingForm = false
    }
  },
  notifications: analyteRangeNotifications
}
</script>
